<com-banner-message location="login" application="login" width="75%"></com-banner-message>

<form [formGroup]="loginFormGroup" class="login">
  @if (step !== loginFormStep.stepBasicLogin) {
    <h2>{{ stepText }}</h2>
  }
  @if (!isAuthenticated) {
    <ng-container [ngSwitch]="step">
      <!----------------------------------------------
      LOGIN - Login
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepBasicLogin">
        <div class="login__title">
          <p class="login__title--main">Welcome to {{ applicationName }}</p>
          <p class="login__title--sub">{{ subtitleText }}</p>
        </div>
        <div class="login__container">
          <ng-container>
            <div [formGroup]="loginFormGroup">
              <div>
                <mat-form-field class="form-field--fill">
                  <mat-label>Email Address</mat-label>
                  <input matInput [formControl]="emailAddress" id="emailAddress" type="text" title="Email address" />
                  <mat-error comFormMessageName="emailAddress" validation="required">Required</mat-error>
                  <mat-error comFormMessageName="emailAddress" validation="pattern">The email format is incorrect.</mat-error>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="form-field--fill">
                  <mat-label>Password</mat-label>
                  <input matInput [formControl]="password" id="password" type="password" title="Password" />
                  <mat-error>Required</mat-error>
                </mat-form-field>
              </div>
              <div class="login__reset-password">
                <a [routerLink]="'/accounts/password/reset'">Forgotten Password?</a>
              </div>
              @if (badLogin) {
                <div>
                  <mat-error>An incorrect username or password was supplied.</mat-error>
                </div>
              }
              <div class="login__buttons">
                <button mat-raised-button (click)="login()" class="login__buttons--continue"><b>Log In</b></button>
              </div>
              <div class="login__buttons" *ngIf="applicationProfile.showSignUpButton">
                <span class="login__buttons__signup--text">Don't have an account?</span>
                <b (click)="signUp()" class="login__buttons__signup--link">Sign up</b>
              </div>
              <a
                href="/docs/eLicensing%20Guidance%20Documents.pdf"
                target="_blank"
                rel="noopener noreferrer"
                *ngIf="applicationProfile.showTermsAndConditions"
              >
                <div class="login__guidance-notes"><mat-icon>picture_as_pdf</mat-icon>Guidance Note For Radio Licensing Users/Applicants</div>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <!----------------------------------------------
      LOGIN - MFA
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepMfa" class="login__container login__small">
        <ng-container>
          <com-mfa (completed)="mfaCompleted($event)"></com-mfa>
        </ng-container>
      </div>
      <!----------------------------------------------
      LOGIN -  Super User
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepSuperUser" class="login__container login__small">
        <ng-container [formGroup]="stepSuperUser">
          <div class="login__step-text">To log in for a chosen account, enter the account code below and click 'Confirm Login'</div>
          <mat-form-field class="form-field--fill">
            <mat-label>Enter Account Code</mat-label>
            <input matInput [formControl]="accountCode" id="accountCode" type="text" title="Account Code" />
            <mat-error>Required</mat-error>
          </mat-form-field>

          @if (!accountCodeIsValid) {
            <mat-error>The supplied Account Code is not valid. Please try again.</mat-error>
          }
          <p class="login__link">
            <span (click)="logout()" class="login__link--text">Cancel log In</span>
          </p>
          <div class="login__buttons">
            <button mat-raised-button class="login__buttons--continue" (click)="validateEnteredAccountCode()">Confirm Account</button>
          </div>
        </ng-container>
      </div>
      <!----------------------------------------------
      LOGIN - Select Contact
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepContact" class="login__container login__small">
        <ng-container [formGroup]="stepContact">
          <div class="login__step-text">Select contact from the list below</div>
          <mat-form-field class="form-field--fill">
            <mat-label>Select Contact</mat-label>
            <mat-select [formControl]="contact" id="contact" title="Select a contact">
              <mat-option [value]="null"></mat-option>
              @for (contact of contacts; track $index) {
                <mat-option [value]="contact">{{ contact.firstName }} {{ contact.lastName }}</mat-option>
              }
            </mat-select>
            <mat-error>The Contact field is not valid.</mat-error>
          </mat-form-field>
          <p class="login__link">
            <span (click)="logout()" class="login__link--text">Cancel log In</span>
          </p>

          <div class="login__buttons">
            <button mat-raised-button class="login__buttons--continue" (click)="confirmContact()">
              {{ this.contactButtonText }}
            </button>
          </div>
        </ng-container>
      </div>
      <!----------------------------------------------
      LOGIN - Select Account
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepAccount" class="login__container login__large">
        <ng-container [formGroup]="stepAccount" *comSpinner="accountsLoading; color: 'primary'; diameter: 35">
          <mat-form-field class="form-field--fill login__search-input">
            <div class="login__search-input--content">
              <mat-icon matTextPrefix>search</mat-icon>
              <input matInput type="text" placeholder="Filter Account Code..." autocomplete="off" (keyup)="applyFilter($event)" />
            </div>
          </mat-form-field>

          <table mat-table [dataSource]="dataSource" matSort class="login__table contrast-table">
            <!-- Account Code -->
            <ng-container matColumnDef="accountCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Account Code</th>
              <td mat-cell *matCellDef="let element" class="mat-column-center">
                <b> {{ element.accountCode }} </b>
              </td>
            </ng-container>

            <!-- Account Name -->
            <ng-container matColumnDef="accountName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Name</th>
              <td mat-cell *matCellDef="let element" class="mat-column-center">
                <b> {{ element.accountName }} </b>
              </td>
            </ng-container>

            <!-- provider type -->
            <ng-container matColumnDef="providerType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Type</th>
              <td mat-cell *matCellDef="let element" class="mat-column-center">
                <b> {{ element.providerTypeString }} </b>
              </td>
            </ng-container>

            <!-- login -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-center">Action</th>
              <td mat-cell *matCellDef="let element" class="mat-column-center">
                <button mat-raised-button type="button">Select</button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="accountSelect(row)"></tr>
          </table>
          <div class="paginator">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            <p class="login__link">
              <span (click)="logout()" class="login__link--text">Cancel log In</span>
            </p>
          </div>
          <span comFormMessageName="account">The account field is not valid.</span>
        </ng-container>
      </div>
      <!----------------------------------------------
      LOGIN - No Account
      ------------------------------------------------>
      <div *ngSwitchCase="loginFormStep.stepNoAccounts" class="login__container">
        <div class="login__step-text">
          <span class="login__step-text--highlighted">There are no accounts associated with this login that can be viewed in this application.</span>
        </div>
        @if (showeLicensingGuidance()) {
          <p class="login__step-text--guidance">
            If you already have an account for Radio Spectrum Licensing (including Broadcasting licenses) or Premium Rate Services, these are dealt
            with in the eLicensing application. <br />Please log in (using the same credentials) to
            <a href="https://elicensing.comreg.ie/">https://elicensing.comreg.ie/</a>
          </p>
        }
        @if (showDataPortalGuidance()) {
          <p class="login__step-text--guidance">
            If you already have an account for Market Intelligence, Network Trust, Retail Offers Submissions, or Network Operations Incident
            Reporting, these are dealt with in the Data.Comreg application. <br />Please log in (using the same credentials) to
            <a href="https://data.comreg.ie/">https://data.comreg.ie/</a>
          </p>
        }
        @if (showSenderIdGuidance()) {
          <p class="login__step-text--guidance">
            If you already have an account for the SMS Sender ID Registry application.
            <br />Please log in (using the same credentials) to <a href="https://senderid.comreg.ie/">https://senderid.comreg.ie/</a>
          </p>
        }
        @if (showeLicensingGuidance()) {
          <p class="login__step-text--guidance">
            If you do not have an existing account, you can register a new <b>Radio Spectrum Licensing or Premium Rate Service</b> account by logging
            in (using the same credentials) to <a href="https://elicensing.comreg.ie/">https://elicensing.comreg.ie/</a> . For
            <b>all other account types</b>, please contact the relevant unit in ComReg.
          </p>
        } @else {
          <p class="login__step-text--guidance">
            If you do not have an existing account, you can register a new <b>Radio Spectrum Licensing or Premium Rate Service</b> account below. For
            <b>all other account types</b>, please contact the relevant unit in ComReg.
          </p>
          <div class="login__buttons">
            <button class="login__buttons--continue" mat-raised-button (click)="applyForAccount()">Register Account</button>
          </div>
        }
        <div class="login__buttons">
          <button class="login__buttons--continue" mat-raised-button (click)="logout()">Log out</button>
        </div>
      </div>
    </ng-container>
  }

  <!----------------------------------------------
    LOGOUT - If is already authenticated
------------------------------------------------>
  <div class="login__form" *ngIf="isAuthenticated">
    <button mat-raised-button (click)="logout()">Log out</button>
  </div>
</form>
